import { render, staticRenderFns } from "./TalkrecordDetail.vue?vue&type=template&id=c1fe0c32&scoped=true"
import script from "./TalkrecordDetail.vue?vue&type=script&lang=js"
export * from "./TalkrecordDetail.vue?vue&type=script&lang=js"
import style0 from "./TalkrecordDetail.vue?vue&type=style&index=0&id=c1fe0c32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1fe0c32",
  null
  
)

export default component.exports